import ApplicationForm from '@/components/forms/ApplicationForm';

export default function Musicians() {
  return (
    <ApplicationForm
      applicationType="musicians"
      title="Musicians & DJs"
      description="We're looking for talented musicians and DJs to perform at Frequency Forest. 
        Whether you're a psytrance producer, progressive DJ, live electronic act, or anything in between, 
        we want to hear from you!"
      showPortfolio={true}
      showExperience={true}
      showRequirements={true}
      showInsurance={false}
      showCertificates={false}
    />
  );
}
